import { createContext } from "react";

export const WishlistContext = createContext(null);
